import styled from "styled-components";

const padding = ({ size }) => {
  switch (size) {
    case "xs":
      return "8px";
    case "lg":
      return "16px";

    case "sm":
    case "md":
    default:
      return "12px";
  }
};

const fontSize = ({ size }) => {
  switch (size) {
    case "xs":
      return "12px";
    case "sm":
      return "14px";
    case "lg":
      return "20px";

    case "md":
    default:
      return "16px";
  }
};

const borderRadius = ({ prefix, suffix, isFile }) => {
  if (isFile) return "none";

  if (prefix) return "8px 0 0 8px";
  if (suffix) return "0 8px 8px 0";

  return "8px";
};

export const Wrapper = styled.div`
  display: grid;
  place-items: center;
  padding: ${padding};
  border-radius: ${borderRadius};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${fontSize};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutral.cinza900};
  background-color: ${({ theme, disabled, isFile }) => {
    if (disabled) return theme.colors.neutral.gray2;

    if (isFile) return theme.colors.neutral.cinza500;

    return "transparent";
  }};
  cursor: ${({ onClick }) => (onClick ? "pointer" : "auto")};
`;
